// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__PUNaH","inputWrap":"Table_inputWrap__XILF8","col":"Table_col__3pjzw","bmiTooltip":"Table_bmiTooltip__20SRa"};